import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { IReviewProps } from "../ReviewParser";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DrawdownPaymentDestinationAllocation } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownPaymentDestinationAllocation";
import { IncomePaymentDestination } from "../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";

interface IProps extends IReviewProps{
    data: PensionContributionModel
}
export const OneOffIncomePaymentReview = (props: IProps) => {
    const { data, onEditAction } = props;

    const config = () => {
        if (!data) return [];
        const {
            Payment,
            DisinvestmentAllocations,
        } = data?.Contribution?.OneOffIncomePaymentModel?.Instruction;
        const {
            CashAvailable,
            CashInstrument,
            EstimatedAssetValueAvailable,
            TotalEstimatedValueAvailable,
        } = data?.Contribution?.OneOffIncomePaymentModel;

        const paymentAmount: Money = Payment.Amount ?? { Amount: 0, Currency: CurrencyCode.GBP };
        const nonCashAllocations =
            DisinvestmentAllocations?.filter((x) => x.ProductId != CashInstrument.ProductId) ?? [];

        const config = [
            {
                title: "Payment amount",
                data: MoneyDisplayHelper.getMoneyFormat(paymentAmount),
            },
            {
                title: "Payment type",
                data: nonCashAllocations.length == 0 ? "Available cash" : "Assets and available cash",
            },
        ];

        const destinationAllocationsToArray: DrawdownPaymentDestinationAllocation[] = Object.values(Payment.PaymentDestinationAllocations);

        if (destinationAllocationsToArray.length != 0) {
            if (destinationAllocationsToArray.length == 1) {
                config.push({
                    title: "Bank account",
                    data: getDestinationDescription(destinationAllocationsToArray[0]),
                });
            } else {
                destinationAllocationsToArray.map((ele, index) => {
                    config.push(
                        {
                            title: "Bank account " + (index + 1),
                            data: getDestinationDescription(ele),
                        },
                        {
                            title: "Proportion " + (index + 1),
                            data: ele.Allocation + "%",
                        }
                    );
                });
            }
        }

        const fromAssets = nonCashAllocations.reduce((total, el) => total + el.Value.Amount, 0);
        const assetRemaining: Money = {
            Amount: EstimatedAssetValueAvailable.Amount - fromAssets,
            Currency: EstimatedAssetValueAvailable.Currency,
        };
        const cashRemaining: Money = {
            Amount: CashAvailable.Amount - paymentAmount.Amount + fromAssets,
            Currency: CashAvailable.Currency,
        };
        const totalRemaining: Money = {
            Amount: TotalEstimatedValueAvailable.Amount - paymentAmount.Amount,
            Currency: TotalEstimatedValueAvailable.Currency,
        };

        config.push(
            {
                title: "Estimated cash remaining",
                data: MoneyDisplayHelper.getMoneyFormat(cashRemaining),
            },
            {
                title: "Estimated asset value remaining",
                data: MoneyDisplayHelper.getMoneyFormat(assetRemaining),
            },
            {
                title: "Estimated total value remaining",
                data: MoneyDisplayHelper.getMoneyFormat(totalRemaining),
            }
        );
        return config;
    };

    const getDestinationDescription = (destination: DrawdownPaymentDestinationAllocation) => {
        if (destination.Destination == IncomePaymentDestination.WrapCash) {
            return "Wrap Cash";
        }
        const bankAccount = data.AllBankAccounts.find((x) => x.BankAccountId == destination.BankAccountId);
        return (
            bankAccount.AccountNumber +
            " " +
            bankAccount.BankCodes.BankCode +
            "-" +
            bankAccount.BankCodes.BranchCode +
            "-" +
            bankAccount.BankCodes.ExtraCode +
            " " +
            bankAccount.HolderName
        );
    };

    return (
        <Accordion label="One off income payment" isOpen={false} onEdit={() => onEditAction()}>
            <div className="pl-34">
                <Typography type="common" config={config()}></Typography>
            </div>
        </Accordion>
    );
};

